/*
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginCallback } from '@okta/okta-react';
import { RequiredAuth } from './SecureRoute';
import { LoginPage } from './LoginPage'
import { AppMain } from './AppMain';
import Loading from './Loading';
import Messages from '../pages/Messages';
import Profile from '../pages/Profile';

const AppRoutes = ({ isLoggedIn }) => {
  console.log("AppRoutes:isLoggedIn", isLoggedIn);

  if (isLoggedIn) {
    return (
      <Routes>
        <Route path="/" element={<Navigate to="/in/dashboard" />} />
        <Route path="login/callback" element={<LoginCallback loadingElement={<Loading />} />} />
        {false &&  <Route path="logout" element={<Navigate to="/" />} /> }
        <Route path="/in" element={<RequiredAuth />}>
          <Route path="/in/activities" element={<AppMain selectedMenu="Activities" />} />
          <Route path="/in/levels" element={<AppMain selectedMenu="Levels" />} />
          <Route path="/in/summary" element={<AppMain selectedMenu="Summary" />} />
          <Route path="/in/scoringRules" element={<AppMain selectedMenu="Scoring Rules" />} />
          <Route path="/in/users" element={<AppMain selectedMenu="Users" />} />
          <Route path="/in/badgeRules" element={<AppMain selectedMenu="Badge Rules" />} />
          <Route path="/in/dashboard" element={<AppMain selectedMenu="Dashboard" />} />
          <Route path="/in/faq" element={<AppMain selectedMenu="FAQ" />} />
          <Route path="/in/digitalSwag" element={<AppMain selectedMenu="Digital Swag" />} />
          <Route path="/in/swag" element={<AppMain selectedMenu="SWAG" />} />
        </Route>
      </Routes>
    )
  } else {
    return (
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="login/callback" element={<LoginCallback loadingElement={<Loading />} />} />
        <Route path="logout" element={<Navigate to="/" />} />
        <Route path="/in/dashboard" element={<LoginPage />} />
      </Routes>
    );
  }

  /*
  return (
    <Routes>
      {isLoggedIn ? (
        <Route path="/" exact={true} element={<LoginPage />} />
      ) : (

        <Route path="/" exact={true} element={<AppMain selectedMenu="Activities" />} />

      )}
      <Route path="login/callback" element={<LoginCallback loadingElement={<Loading />} />} />
      <Route path="logout" element={<Navigate to="/" />} />
      <Route path="/in" element={<RequiredAuth />}>
        {0 && <Route path="/in/profile" element={<Profile />} />}
        <Route path="/in/activities" element={<AppMain selectedMenu="Activities" />} />
        <Route path="/in/achievements" element={<AppMain selectedMenu="Achievements" />} />
        <Route path="/in/summary" element={<AppMain selectedMenu="Summary" />} />
        <Route path="/in/scoringRules" element={<AppMain selectedMenu="Scoring Rules" />} />
        <Route path="/in/users" element={<AppMain selectedMenu="Users" />} />
        <Route path="/in/badgeRules" element={<AppMain selectedMenu="Badge Rules" />} />
        <Route path="/in/dashboard" element={<AppMain selectedMenu="Dashboard" />} />

      </Route>
    </Routes>
  );
  */
};

export default AppRoutes;
